/**
 * Centralized Mexican-peso formatter. Every customer-facing money string
 * in ue-web must go through this helper so the locale + decimal rules
 * stay identical across catalog, product page, cart, checkout and order
 * confirmation. Before this lived as a copy-pasted const in ~10 files;
 * any tweak to formatting (e.g. dropping trailing zeros on whole pesos)
 * had to be applied N times and inevitably drifted.
 *
 * Accepts numbers or numeric strings (the API serializes decimal columns
 * as strings — `Number(...)` coerces them safely; non-numeric input
 * yields `NaN` which `Intl.NumberFormat` renders as a localized "NaN"
 * label, surfacing the upstream bug instead of silently writing "$0.00").
 */
export const fmtMxn = (n: number | string): string =>
  Number(n).toLocaleString("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  });
